<template>
  <sl-table :page="false" :columns="columns" :data="data"></sl-table>
</template>
<script>
export default {
  data() {
    return {
      columns: [
        {
          type: 'index',
          width: 60,
          title: '序号',
          align: 'center'
        },
        {
          title: '流水号',
          key: 'tradeSerialNum',
          // width:150,
        },
        {
          title: '金额',
          key: 'payAmount',
          // width:60,
        },
        {
          title: '类型',
          key: 'tradeTypeText',
          // width:60,
        },
        {
          title: '来源',
          key: 'paySourceText',
          // width:60,
        },
        {
          title: '支付方式',
          key: 'payTypeText',
          // width:60,
        },
        {
          title: '支付时间',
          key: 'tradeDatetimeText',
          // width:120,

        },
        {
          title: '第三方订单号',
          key: 'thirdTrandeSerialNum',
          // width:150,

        },
        {
          title: '状态',
          key: 'payStatusText',
          // width:60,
        }
      ],
      data:[],
      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      loading:false
    }
  },

  props: {
    carId: {
      type: [Number, String]
    }
  },
  created(){
    this.$watch('carId' , function(nv){
      if (nv) {
        this.init()
      }
    },{immediate:true})
  },
  methods: {
    init() {
      //let params = { search: { carId: this.carId }, pageSize: this.page.pageSize, pageNum: this.page.pageNum }
      this.loading = true
      this.$request.carBills(this.carId).then(resp => {
        this.loading = false
        if (!resp.code) {
          this.data = this.$utils.conv(resp.data || [], { 'tradeType': '$tradeType', 'tradeDatetime': 'datetime', 'tradeObjType': '$paySource','payType':'$payType','payStatus':'$payStatus' })
          //this.page.total = resp.data.total || 0
        }
      })
    }
  }
}

</script>
